module.exports = __webpack_public_path__ + "static/media/4x6no3.223d3f4c.jpg";